import { render, staticRenderFns } from "./index.vue?vue&type=template&id=405aa8ba&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=405aa8ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405aa8ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('405aa8ba')) {
      api.createRecord('405aa8ba', component.options)
    } else {
      api.reload('405aa8ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=405aa8ba&scoped=true&", function () {
      api.rerender('405aa8ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layouts/HeaderBar/index.vue"
export default component.exports